import $ from "jquery";

if (document.querySelector(".longCardSlider__slider")) {
  $(".longCardSlider__slider").slick({
    slidesToShow: 2.2,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    prevArrow: "<button type='button' class='slick-prev d-none'></button>",
    nextArrow: "<button type='button' class='slick-next d-none'></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}
